// LENGS requests
export const LENGS_LIST = "LENGS_LIST";
export const LENGS_CREATE = "LENGS_CREATE";
export const LENGS_FILTER = "LENGS_FILTER";
export const LENGS_UPDATE = "LENGS_UPDATE";
export const LENGS_DELETE = "LENGS_DELETE";
export const LENGS_READ = "LENGS_READ";

// LENGS success
export const LENGS_LIST_SUCCESS = "LENGS_LIST_SUCCESS";
export const LENGS_CREATE_SUCCESS = "LENGS_CREATE_SUCCESS";
export const LENGS_UPDATE_SUCCESS = "LENGS_UPDATE_SUCCESS";
export const LENGS_DELETE_SUCCESS = "LENGS_DELETE_SUCCESS";
export const LENGS_READ_SUCCESS = "LENGS_READ_SUCCESS";

// LENGS failed
export const LENGS_REQUEST_FAILED = "LENGS_REQUEST_FAILED";
